import type { Address } from '../types/Address';
import type { DeliveryProps } from '../types/ContextProps';
import { setLocalStorage } from './localStorage';

export const deliverySetData = (
  address?: Address,
  deliveryRequestInfos?: DeliveryProps,
  postalCode?: string
) => {
  const deliveryInfos = JSON.stringify({
    city: String(address?.localidade),
    uf: String(address?.uf),
    deliveryName: String(deliveryRequestInfos?.deliveryName),
    shippingEstimate: String(deliveryRequestInfos?.shippingEstimate),
  });

  setLocalStorage('postalCode', postalCode ?? '');
  setLocalStorage('method', 'delivery');
  setLocalStorage('deliveryInfos', deliveryInfos);
};
